export default __webpack_public_path__ + "static/media/quick-checkup-img.45d0888b.svg";